export enum LossOrScrapSourceEnum {
    RAW_MATERIAL = 'rawMaterial',
    FINAL_PRODUCT = 'finalProduct'
}
